export const LazyCss = ({ url }) => (
  <>
    <link rel="preload" href={url} as="style" />
    <noscript>
      <link rel="stylesheet" href={url} />
    </noscript>
  </>
);
